import { render, staticRenderFns } from "./resourceManager.vue?vue&type=template&id=0c630fb8&"
import script from "./resourceManager.vue?vue&type=script&lang=js&"
export * from "./resourceManager.vue?vue&type=script&lang=js&"
import style0 from "./resourceManager.vue?vue&type=style&index=0&id=0c630fb8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports